import React from 'react';
import { Table, Alert, Button, Loader, Card } from 'kepler';

let nextPageId = '',
  notLoading = true,
  dataError = false;

class DonationHistory extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        charityName: this.props.charityName || '',
        donationData: this.props.donationData.dashboard,
        loader: false
      };
    }

  componentDidMount() {
    const self = this;
    $(window).on('scroll', function () {
      let $elem = $('#donationTable'),
        docViewTop = $(window).scrollTop(),
        docViewBottom = docViewTop + $(window).height(),
        elemTop = $elem.offset().top,
        elemBottom = elemTop + $elem.height();
      if (elemBottom < docViewBottom && notLoading && !dataError) {
        notLoading = false;
        $('#loadmorespinner').show();
        self.startLoadingMoreSearchResults();
      }
    });

    $('#donationTableMain').on('click', 'tr.activityRow', function () {
      $(this).toggleClass('expanded');
      $('.icon-arrow-down-small', this).toggleClass('icon-arrow-up-small');
      let activityDetailRow = $(this).next();
      activityDetailRow.toggle();
    });
  }

  startLoadingMoreSearchResults() {
    const self = this;
    let csrf = $('body').attr('data-csrf'),
      scrollId = $('#scrollId').val();
    notLoading = false;

    const params = {
      _csrf: csrf,
      scrollId: scrollId,
      loadmore: true
    };

    $.post('/givingfund/partner/dashboard', params, (result) => {
      if (result.transactions.length == 0) {
        notLoading = false;
        $("#loadmorespinner").hide();
        return;
      }
      notLoading = true;
      let oldData = self.state.donationData, // Array of data
        newData = result.transactions,
        combinedData = oldData.concat(newData);
      self.setState({
        donationData: combinedData
      });
      $('#loadmorespinner').hide();
    });
  }

  render() {
    let self = this;
    let renderDonationHistoryTable = [];

    if (self.state.donationData.length) {
      renderDonationHistoryTable = self.state.donationData.map(function(
        result,
        index
      ) {
        //Send last record payout time as scrollId
        if (index == self.state.donationData.length - 1) nextPageId = result.payout_time;
          
        let payoutMsg = '',
            pymtClass = '';
        if (result.payout_status == '0') {
            payoutMsg = (result.payout_mode && result.payout_mode == 'CHEQUE') ? 'Cheque Payment' : 'Paypal Payment';
            pymtClass = 'paidMode';
            
        } else if (result.payout_status == '1'){
          payoutMsg = (result.payout_mode && result.payout_mode == 'CHEQUE') ? 'Cheque Payment Failed' : 'Paypal Payment Failed';
          pymtClass = 'paidMode error'
        }
        else if (result.payout_status == '2'){
          payoutMsg = (result.payout_mode && result.payout_mode == 'CHEQUE') ? 'Cheque Payment Deposited' : '';
          pymtClass = 'paidMode'
        }
        return (
          <tbody key={index}>
            <tr className="activityRow">
              <td width="10%">
                <div className="dateBlock">
                  <span className="month">{result.month}</span>
                  <span className="date">{result.date}</span>
                  <span className="year">{result.year}</span>
                </div>
              </td>
              <td width="75%" className="v_middle">
                {result.partnerName}
                <i className="icon icon-arrow-down-small" />
                <div className={pymtClass}>{payoutMsg}</div>
              </td>
              <td width="15%" className="v_middle">
                <span className={result.sign} />
                {result.amount}
              </td>
            </tr>
            <tr className="activityDetailRow">
              <td />
              <td colSpan="2">
                {result.program_monthly_payouts_list.map(function(res, inx) {
                  return (
                    <div width="100%" className="subTable">
                      <div className="pull-left">{res.payout_description}</div>
                      <div className="pull-right">
                        <span className={res.sign} />
                        {res.amount}
                      </div>
                    </div>
                  );
                })}
              </td>
            </tr>
          </tbody>
        );
      });
    } else {
      dataError = true;
      renderDonationHistoryTable = (
        <Alert type="info">
          No data found!
        </Alert>
      );
    }

    return (
      <Card>
        <Loader
          show={this.state.loader}
          priority={10}
          type="fixed"
          size="lg"
          opacity={0.5}
        />
        <div className="header">
          <h3>Donation History</h3>
          <p>
            Total monthly donations (excluding any requested refunds) appear
            below once we issue payment to the charity on the date shown. To
            view donation details for each month, including refunds, view &nbsp;
            <a href="/givingfund/partner/activity">Activity</a>.
          </p>
        </div>
        <div id="donationTable">
          <Table id="donationTableMain" width="100%">
            {renderDonationHistoryTable}
          </Table>
        </div>
        <Loader
          show={true}
          priority={10}
          size="md"
          opacity={0.5}
          id="loadmorespinner"
        >
          Loading...
        </Loader>
        <input type="hidden" name="scrollId" id="scrollId" value={nextPageId} />
      </Card>
    );
  }
}
export default DonationHistory;


// WEBPACK FOOTER //
// ./partner/components/donationHistory.js